import * as React from "react";
const SvgFiBrandsTikTok = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M22.465 9.866a9.8 9.8 0 0 1-5.74-1.846v8.385c0 4.188-3.407 7.594-7.594 7.594a7.55 7.55 0 0 1-4.352-1.376 7.59 7.59 0 0 1-3.242-6.218c0-4.188 3.407-7.595 7.595-7.595.348 0 .688.029 1.023.074v4.212a3.4 3.4 0 0 0-1.023-.16 3.47 3.47 0 0 0-3.468 3.469 3.47 3.47 0 0 0 3.47 3.468 3.47 3.47 0 0 0 3.461-3.338L12.598 0h4.126q.002.537.097 1.047a5.75 5.75 0 0 0 5.643 4.694z"
    />
  </svg>
);
export default SvgFiBrandsTikTok;
